import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, FormControl, IconButton, MenuItem, Select } from '@material-ui/core';
import { EditOutlined } from '@material-ui/icons';
import VariantService from '../../../../services/VariantService/VariantService';
import './Config.css';
/**
 * @Description This function returns Config section.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Config({ state, setState }) {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const [variables, setVariables] = useState([]);
    const [select, setSelect] = useState(state.variant.first[0]);

    useEffect(() => {
        fetchData(state.variant.first[0]);
    }, []);

    const fetchData = async (item) => {
        if (item?.config) {
            setVariables(item.config);
        } else if (item) {
            const res = await VariantService.getVariantConfig(item.bot_id, 'local');
            if (res?.status) {
                item.config = res.data;
                setVariables(res.data);
                localStorage.setItem('variant_state', JSON.stringify(state));
                setState({ ...state });
            } else {
                item.config = [];
                setVariables([]);
            }
        }
    };

    const handleChange = (e) => {
        fetchData(e.target.value);
        setSelect(e.target.value);
    };

    return (
        <div className="vconfig">
            <FormControl variant="outlined" size="small" fullWidth>
                <Select value={select} onChange={handleChange}>
                    {state.variant.first.map((item, itemI) =>
                        <MenuItem key={itemI} className="vconfig-variant" value={item}>{item.name}</MenuItem>
                    )}
                </Select>
            </FormControl>
            <div className="vvariables">
                <table>
                    <tbody>
                        {variables.length > 0 ?
                            variables.map((item, itemI) => <Row key={itemI} item={item} state={state} setState={setState} />):
                            t(label + 'NO-CONFIG')
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}
function Row ({ item, state, setState }) {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const [edit, setEdit] = useState(item.value ? false : true);
    const [value, setValue] = useState(item.value ? item.value : '');
    useEffect(() => {
        setValue(item.value ? item.value : '');
        setEdit(item.value ? false : true);
    }, [item]);
    const handleChange = (e) => { setValue(e.target.value); };
    const handleClick = () => { setEdit(true); };
    const handleSave = () => {
        if (/\S/.test(value)) {
            item.value = value;
            setEdit(false);
            localStorage.setItem('variant_state', JSON.stringify(state));
            setState({ ...state });
        }
    };
    return (
        <tr className="vvariable">
            <td>{item.name}</td>
            <td>{item.type}</td>
            <td>{edit ? <input value={value} onChange={handleChange} placeholder={t(label + 'TYPE-VALUE')} /> : item.value}</td>
            <td>{edit ?
                <Button onClick={handleSave} size="small">{t(label + 'SAVE')}</Button> :
                <IconButton onClick={handleClick} size="small"><EditOutlined fontSize="small" /></IconButton>}
            </td>
        </tr>
    );
}
export default Config;